export var VerificationStepStatus;
(function (VerificationStepStatus) {
    VerificationStepStatus["pending"] = "pending";
    VerificationStepStatus["in_progress"] = "in_progress";
    VerificationStepStatus["completed"] = "completed";
    VerificationStepStatus["rejected"] = "rejected";
    VerificationStepStatus["skipped"] = "skipped";
})(VerificationStepStatus || (VerificationStepStatus = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType["business_license"] = "business_license";
    DocumentType["tax_certificate"] = "tax_certificate";
    DocumentType["identity_card"] = "identity_card";
    DocumentType["passport"] = "passport";
    DocumentType["bank_statement"] = "bank_statement";
    DocumentType["address_proof"] = "address_proof";
    DocumentType["other"] = "other";
})(DocumentType || (DocumentType = {}));
export var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["pending"] = "pending";
    DocumentStatus["verified"] = "verified";
    DocumentStatus["rejected"] = "rejected";
    DocumentStatus["expired"] = "expired";
})(DocumentStatus || (DocumentStatus = {}));
export var VerificationProcessStatus;
(function (VerificationProcessStatus) {
    VerificationProcessStatus["not_started"] = "not_started";
    VerificationProcessStatus["in_progress"] = "in_progress";
    VerificationProcessStatus["completed"] = "completed";
    VerificationProcessStatus["rejected"] = "rejected";
    VerificationProcessStatus["expired"] = "expired";
})(VerificationProcessStatus || (VerificationProcessStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVmVyaWZpY2F0aW9uUHJvY2Vzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy92ZXJpZmljYXRpb24vVmVyaWZpY2F0aW9uUHJvY2Vzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnQkEsTUFBTSxDQUFOLElBQVksc0JBTVg7QUFORCxXQUFZLHNCQUFzQjtJQUNoQyw2Q0FBbUIsQ0FBQTtJQUNuQixxREFBMkIsQ0FBQTtJQUMzQixpREFBdUIsQ0FBQTtJQUN2QiwrQ0FBcUIsQ0FBQTtJQUNyQiw2Q0FBbUIsQ0FBQTtBQUNyQixDQUFDLEVBTlcsc0JBQXNCLEtBQXRCLHNCQUFzQixRQU1qQztBQWFELE1BQU0sQ0FBTixJQUFZLFlBUVg7QUFSRCxXQUFZLFlBQVk7SUFDdEIscURBQXFDLENBQUE7SUFDckMsbURBQW1DLENBQUE7SUFDbkMsK0NBQStCLENBQUE7SUFDL0IscUNBQXFCLENBQUE7SUFDckIsaURBQWlDLENBQUE7SUFDakMsK0NBQStCLENBQUE7SUFDL0IsK0JBQWUsQ0FBQTtBQUNqQixDQUFDLEVBUlcsWUFBWSxLQUFaLFlBQVksUUFRdkI7QUFFRCxNQUFNLENBQU4sSUFBWSxjQUtYO0FBTEQsV0FBWSxjQUFjO0lBQ3hCLHFDQUFtQixDQUFBO0lBQ25CLHVDQUFxQixDQUFBO0lBQ3JCLHVDQUFxQixDQUFBO0lBQ3JCLHFDQUFtQixDQUFBO0FBQ3JCLENBQUMsRUFMVyxjQUFjLEtBQWQsY0FBYyxRQUt6QjtBQWVELE1BQU0sQ0FBTixJQUFZLHlCQU1YO0FBTkQsV0FBWSx5QkFBeUI7SUFDbkMsd0RBQTJCLENBQUE7SUFDM0Isd0RBQTJCLENBQUE7SUFDM0Isb0RBQXVCLENBQUE7SUFDdkIsa0RBQXFCLENBQUE7SUFDckIsZ0RBQW1CLENBQUE7QUFDckIsQ0FBQyxFQU5XLHlCQUF5QixLQUF6Qix5QkFBeUIsUUFNcEMifQ==